export class Sector {
    constructor(
      public hash?: string,
      public title?: string
    ) { }

    clone() {
      return new Sector(
        this.hash,
        this.title
      );
    }
  }

